import { Radio } from 'antd'
import React from 'react'

export interface RadioFieldProps {
  id: string
  value?: string
  onChange?: (arg) => void
  options?: { label: string | undefined; value: string | undefined }[]
  layout?: 'row' | 'column'
  disabled?: boolean
  readOnly?: boolean
}

const RadioField: React.FC<RadioFieldProps> = ({
  id,
  value,
  onChange,
  layout,
  options,
  disabled,
  readOnly
}) => {
  const style: React.CSSProperties | undefined =
    layout === 'column' ? { display: 'flex', flexDirection: 'column', gap: 8 } : undefined

  return (
    <Radio.Group value={value} disabled={disabled ?? readOnly} onChange={onChange} style={style}>
      {options?.map((option, index) => (
        <Radio name={`${id}-${option.value}`} key={index} value={option.value}>
          {option.label}
        </Radio>
      ))}
    </Radio.Group>
  )
}

export default RadioField
